module.exports = __webpack_public_path__ + "static/media/bg-map.3d5abe04.png";